import { render, staticRenderFns } from "./CryptoRegistrationCancelModal.vue?vue&type=template&id=520bb037&scoped=true"
import script from "./CryptoRegistrationCancelModal.vue?vue&type=script&lang=js"
export * from "./CryptoRegistrationCancelModal.vue?vue&type=script&lang=js"
import style0 from "./CryptoRegistrationCancelModal.vue?vue&type=style&index=0&id=520bb037&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520bb037",
  null
  
)

export default component.exports